import { Context, createContext } from "react";
import AuthService from "./authService";

const authContext: Context<AuthService> = createContext(new AuthService());

export default authContext;
